const SnsLogin_en = {
  ID_ACCOUNT_ALREADY_EXIST: "Do you already have an account?",

  ID_SNS_BUTTON_METAMASK: "Sign in with Metamask Wallet",
  ID_SNS_BUTTON_NAVER: "Sign in with Naver",
  ID_SNS_BUTTON_KAKAO: "Sign in with Kakao",
  ID_SNS_BUTTON_FACEBOOK: "Sign in with Facebook",
  ID_SNS_BUTTON_GOOGLE: "Sign in with Google",
  ID_SNS_BUTTON_OTHER: "Start with a different SNS",
  ID_SNS_BUTTON_MICROSOFT: "Sign in with Microsoft",

  ID_LAST_LOGIN_TOOLTIP: "This is the last SNS I logged in",

  ID_ACCOUNT_ALREADY_EXIST_NOTICE: "I found the account",
  ID_AGAIN_LOGIN_BUTTOM: "Login again",
  ID_EXIST_ACCOUNT_INFO_NOTICE_TITLE: "I found\nthe account",
  ID_ORIGINAL_ACCOUNT_CONNECT_BUTTON:
    "Interworking with existing Redbrick accounts",

  ID_CONNECT_ACCOUNT: "Do you want me to link your account?",
  ID_CONNECT_ACCOUNT_PASSWORD:
    "Please enter the password of the existing Redbrick account",

  ID_SNS_COMPLETE_REGISTER_TITLE: "Sign up completed",
  ID_SNS_COMPLETE_REGISTER_SUB_TITLE: "Welcome to Redbrick!",
  ID_SNS_COMPLETE_REGISTER_INTRO: "Let me introduce Redbrick",
  ID_SNS_ABOUT_REDBRICK_FIRST_TITLE: "a surprisingly easy creation",
  ID_SNS_ABOUT_REDBRICK_FIRST_SUB_TITLE:
    "Easily create the world you want\nwith thousands of sets and block coding.",

  ID_SNS_ABOUT_REDBRICK_SECOUND_TITLE: "My content is profitable",
  ID_SNS_ABOUT_REDBRICK_SECOUND_SUB_TITLE:
    "Sell your creations in the marketplace\nor insert ads into the world to make a profit.",

  ID_LABEL_TO_BE_INTRODUCE: "To be introduced",

  ID_NEXT_STEP_BUTTON: "Next",

  ID_SNS_EMAIL: "Email",
  ID_SNS_CREATED_AT: "CreatedAt",

  ID_SNS_TOAST_MSG_LOGIN: "Login complete with an SNS account",
  ID_SNS_TOAST_MSG_LOGOUT: "Logout complete",
  ID_SNS_TOAST_MSG_SIGNUP: "SignUp complete with an SNS account",
  ID_SNS_TOAST_MSG_CONNECT: "I've completed linking my account",

  ID_SNS_CONNECT_COMPLETE_TITLE: "계정 연동을\n완료했어요",
  ID_SNS_CONNECT_COMPLETE_SUB:
    "이제 내 계정을 한번에 편리하게 관리할 수 있어요",
  ID_SNS_CONNECT_COMPLETE_POINT_1:
    "계정 연동이 완료되면 어떤 계정으로 로그인하든 같은 정보를 볼 수 있어요.",
  ID_SNS_CONNECT_COMPLETE_POINT_2:
    "연동된 계정은 삭제되지 않으며 기존과 동일하게 로그인할수 있어요",
  IS_SNS_CONNECT_COMPLETE_BUTTON: "메인으로",
  ID_SNS_REDBRICK_ACCOUNT: "레드브릭 계정",
  ID_SNS_ACCOUNT: "SNS 계정",
  ID_SNS_ALREADY_CONNECTED_ERR: "이미 해당 SNS로 연동된 계정이 있습니다.",
};

export default SnsLogin_en;
